import type { Path } from "react-router-dom"

import type { DeviceSettings } from "types/device.types"
import type { Tab } from "types/tabs.types"
import {
  getOtherDeviceTypesTabsConfig,
  getSentriPowerlineTabsConfig,
  getSentriTowerTabsConfig,
  getVirtualPowerlineTabsConfig,
  getWeatherStationTabsConfig,
} from "./deviceTabsConfig"

export const getTabValue = (path: string, tabConfig: Tab[]): number => {
  const tabsWithoutMain = tabConfig.filter((tab) => tab.value !== 0)
  const tab = tabsWithoutMain.find((tab) => path.includes((tab.to as Path).pathname))
  return tab ? tab.value : 0
}

export const getDashboardTabsConfig = (
  search: string,
  deviceType: string,
  deviceSettings?: DeviceSettings | undefined,
): Tab[] => {
  // this condition is temporary until deviceType "tower"
  // then it can enter in the switch default statement
  if (deviceSettings?.installation_type === "tower") {
    const hasAmbientTab = !!deviceSettings?.features?.weather?.was_enabled
    return getSentriTowerTabsConfig(search, hasAmbientTab)
  }

  switch (deviceType) {
    case "sentrisense": {
      const hasAmbientTab = !!(
        deviceSettings?.installation_type === "powerline" &&
        deviceSettings?.geo_location?.latitude &&
        deviceSettings?.geo_location?.longitude
      )
      return getSentriPowerlineTabsConfig(search, hasAmbientTab)
    }
    case "virtual_powerline":
      return getVirtualPowerlineTabsConfig(search)
    case "weather_station":
      return getWeatherStationTabsConfig(search)
    default:
      return getOtherDeviceTypesTabsConfig(search)
  }
}
